import React from "react";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { useGetCuisineQuery } from "api/cuisine";
import { Link } from "react-router-dom";

export const AllCuisineCards = () => {
  const { data: getCuisine } = useGetCuisineQuery();
  const realData = getCuisine?.data;
  console.log("cuines", realData);

  const data = [
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
    },
    {
      title: "Mexican",
      image: "./images/Taco_revisi.svg",
      dispProp: "flex",
    },
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
    },
    {
      title: "Mexican",
      image: "./images/Taco_revisi.svg",
      dispProp: "flex",
    },
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
    },
    {
      title: "Mexican",
      image: "./images/Taco_revisi.svg",
      dispProp: "flex",
    },
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
      component: null,
    },
    {
      title: "Mexican",
      image: "./images/Taco_revisi.svg",
      dispProp: "flex",
    },
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
      component: null,
    },
    {
      title: "Mexican",
      image: "./images/Taco_revisi.svg",
      dispProp: "flex",
    },
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
      component: null,
    },
    {
      title: "Mexican",
      image: "./images/Taco_revisi.svg",
      dispProp: "flex",
    },
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
      component: null,
    },
    {
      title: "Mexican",
      image: "./images/Taco_revisi.svg",
      dispProp: "flex",
    },
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
      component: null,
    },
    {
      title: "Mexican",
      image: "./images/Taco_revisi.svg",
      dispProp: "flex",
    },
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
      component: null,
    },
    {
      title: "Mexican",
      image: "./images/Taco_revisi.svg",
      dispProp: "flex",
    },
    {
      title: "American",
      image: "./images/allmenudish.svg",
      dispProp: "flex",
    },
    {
      title: "French",
      image: "./images/Cassoulet.svg",
      dispProp: "flex",
    },
    {
      title: "Italian",
      image: "./images/Spaghetti.svg",
      dispProp: "flex",
      component: null,
    },
    {
      title: "Mexican",
      image: "./images/Taco_revisi.svg",
      dispProp: "flex",
    },
  ];
  return (
    <>
      <Box
        component="container"
        sx={{
          mt: "30px",
          justifyContent: { sm: "center" },
          alignItems: { sm: "center" },
        }}
      >
        <Box>
          <Typography
            sx={{ fontSize: "40px", fontWeight: "600", paddingBottom: "16px" }}
          >
            All cuisines
          </Typography>
        </Box>

        <Grid container spacing={2}>
          {data.map((v, i) => {
            return (
              <>
                <Grid item lg={3} md={4} sm={6} xs={12}>
                  <Link
                    to="/American_Cuisine"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "#F0FAF9",
                        backgroundImage: "url(./images/thread.svg)",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "left top",
                        width: "306px",
                        height: "122px",
                        borderRadius: "8px",
                      }}
                    >
                      <Box
                        sx={{
                          display: `${v.dispProp}`,
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <Typography
                            sx={{ fontSize: "24px", fontWeight: "600" }}
                          >
                            {v.title}
                          </Typography>
                        </Box>
                        <Box>
                          <img src={v.image} alt="" />
                        </Box>
                        {/* <Box component= {`${v.component}`}>{`${v.button}`}</Box> */}
                      </Box>
                    </Box>
                  </Link>
                </Grid>
              </>
            );
          })}
        </Grid>
      </Box>
    </>
  );
};
